export type DateTimeUnit = 'Y' | 'M' | 'D' | 'W' | 'h' | 'm';

export interface DateFilterModifier {
  unit: DateTimeUnit;
  value: number;
}

export interface Modifier {
  label: string;
  type: DateTimeUnit;
}

export const dateTimeUnits: Modifier[] = [
  {
    label: 'Years',
    type: 'Y',
  },
  {
    label: 'Months',
    type: 'M',
  },
  /*
  {
    label: 'Weeks',
    type: 'W'
  },
  */
  {
    label: 'Days',
    type: 'D',
  },
  {
    label: 'Hours',
    type: 'h',
  },
  {
    label: 'Minutes',
    type: 'm',
  },
];
